export const zhCN_menu = {
	'app.menu.parent': '顶级菜单',
	'app.menu.dashboard': '首页',
	'app.menu.dashboard.workbench': '工作台',
	'app.menu.dashboard.analysis': '分析页',

	'app.menu.form': '表单页',
	'app.menu.form.basic': '基础表单',
	'app.menu.form.advanced': '高级表单',
	'app.menu.form.editor': '富文本',

	'app.menu.list': '列表页',
	'app.menu.list.search': '搜索列表',

	'app.result': '结果页',
	'app.result.success': '成功页',
	'app.result.failed': '失败页',

	'app.abnormal': '异常页',
	'app.abnormal.403': '403',
	'app.abnormal.404': '404',
	'app.abnormal.500': '500',

	'app.org': '组织',
	'app.org.dept': '部门',
	'app.org.account': '账户',
	'app.org.role': '角色',
	'app.org.permission': '权限',

	'app.user': '个人',
	'app.user.center': '个人中心',
	'app.user.settings': '个人设置',

	'app.menu.login': '登录',
	'app.menu.config': '配置',
	'app.menu.config.search': '菜单管理',
	'app.menu.config.code.search': '字典管理',
	'app.menu.config.notice.search': '公告管理',
	'app.menu.config.schedule.search': '批处理管理',
	'app.menu.config.schedule.log': '批处理日志',
	'app.menu.config.theme': '主题设置',
	'app.menu.logs': '日志',
	'app.menu.logs.search': '日志管理',
	// 监控中心
	'app.menu.monitor': '监控中心',
	'app.menu.monitor.online': '在线用户',
	'app.menu.monitor.server': '服务监控',
	// 通知中心
	'app.menu.notice': '通知中心',
	'app.menu.notice.message': '站内信',
	// AI 能力
	'app.menu.ai': 'AI 能力',
	'app.menu.ai.mcp.servers': 'MCP 服务',
	'app.menu.ai.llm.providers': '模型供应商',
	'app.menu.ai.llm.prompts': '提示词',
	'app.menu.ai.training': '训练场'
}
